const menuStore = {
  namespaced: true,
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {}
};

export default menuStore;
